import { Grid, Modal, makeStyles, Button, TextField } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '5px'
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(255,255,255,0.15)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255)',
      borderRadius: '8px'
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ededef'
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

const AlertLengthModal = ({ open, onClose, message }) => {
  const classes = useStyles();

  return (
    <Modal
      className={classes.modal}
      open={open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEscapeKeyDown
    >
      <div className="capture-flags-modal">
        <span style={{ textAlign: 'center', marginTop: '10px' }}>
          {message}
        </span>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: '20px' }}
        >
          <Grid item xs={3}>
            <Button
              className="capture-flags-modal-close-btn"
              style={{ justifyContent: 'center' }}
              onClick={onClose}
            >
              <span className="btn__title">Close</span>
            </Button>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};
export default AlertLengthModal;
